<div class="aggregation-trigger">
  <div class="aggregation-header">
    <h3>{{ pageTitle }}</h3>
  </div>

  <div class="aggregation-body">
    <div class="records-list">
      <label>Select records:</label>
      @for (option of triggerOptions; track $index) {
<div class="record-item">
        <input type="checkbox" [value]="option.value" [ngModel]="selectedValues.includes(option.value)" (ngModelChange)="toggleSelection(option.value, $event)" />
        <span>{{ option.name }}</span>
      </div>
}
    </div>

    <div class="actions">
      <button class="btn btn-warning" type="button" (click)="triggerSelected()">Trigger</button>
      <button class="btn btn-primary" type="button" (click)="triggerWhole()">Whole Trigger</button>
    </div>
  </div>
</div>

@if (showConfirmDialog) {
<div class="confirm-overlay">
  <div class="confirm-dialog" (click)="$event.stopPropagation()">
    <gtw-confirmation-modal
      [config]="confirmModalConfig"
      [visible]="true"
      (confirmed)="onConfirm()"
      (cancelled)="onCancelConfirm()"
      (closed)="onCancelConfirm()">
    </gtw-confirmation-modal>
  </div>
</div>
}
